import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import {useDropzone} from 'react-dropzone'
import { Icon, Button, Loader, Dimmer, Checkbox,CheckboxProps, Grid, Form, Input } from 'semantic-ui-react'
import styles  from './Dropzone.module.css'
import { filePeview } from '../../shared/interfaces'
import ClientCaptcha from "react-client-captcha";
import { Cookies, getCookieConsentValue } from "react-cookie-consent";
import { useEffect } from 'react';
export interface IDropzoneProps {
  inputFiles?: Array<filePeview>,
  onChange: (files: Array<filePeview>) => void,
  uploadButtonCaption: string,
  cancelButtonCaption: string,
  handleUpload: () => void,
  handleReset: () => void,
  dimmerText:string
}

export const Dropzone =({
  inputFiles = [],
  onChange,
  uploadButtonCaption,
  cancelButtonCaption,
  handleUpload,
  handleReset,
  dimmerText
}:IDropzoneProps) => {
  
  const { t,i18n } = useTranslation();
  const [dataProtection, setDataProtection] = useState(false);
  const [captcha, setCaptcha] = useState('');
  const [userCaptcha, setUserCaptcha] = useState('')
  const [userName, setUserName] = useState('')
  const [userNameError, setUserNameError] = useState<string|undefined>(undefined)
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState<string|undefined>(undefined)
  const [preview, setPreview] = useState<Array<filePeview>>([]);
  const [tel, setTel]= useState('')
  //const [telError, setTelError] = useState<string|undefined>(undefined)
  const [saveCookies,setSaveCookies] = useState(false);
  useEffect(() => {

    const userName =Cookies.get("ovsc-userName");
    const email =Cookies.get("ovsc-email");
    const tel =Cookies.get("ovsc-tel");
    if (userName!==undefined && userName!==null && userName!=='')
    {
     setUserName(userName) 
    }
    if (email!==undefined && email!==null && email!=='')
    {
     setEmail(email)  
    }
    if (tel!==undefined && tel!==null && tel!=='')
    {
     setTel(tel)  
    } 
  },[]);

  
  useEffect(() => {
    const isConsent = getCookieConsentValue();
    setSaveCookies(isConsent === "true");
  }, []);

  const language = i18n.language.substr(0,2);
  
  const languageString = t("menue." +language);

  const mailRegExp = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  const telRegExp = new RegExp(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[-. \\/]?)?((?:\(?\d{1,}\)?[-. \\/]?){0,})(?:[-. \\/]?(?:#|ext\.?|extension|x)[-. \\/]?(\d+))?$/i)
  const {getRootProps, getInputProps, isDragActive} = useDropzone({multiple:false, onDrop: filesToUpload => { 
    const pv: Array<filePeview> = [];
    const file:File = filesToUpload[0];
    if (preview.length>0) {
      URL.revokeObjectURL(preview[0].preview);
    }
    
    pv.push({
      preview: URL.createObjectURL(file),
      name: file.name,
      type: file.type,
      lastModified: file.lastModified,
      userName:userName,
      email:email,
      tel:tel,
      lang:languageString
    })
    setPreview(pv);
    onChange(pv);
   }
  })
  const getCaptchaCode =(code:string) => {
    setCaptcha(code);
   }

  const dataProtectionChange = (event: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {
    setDataProtection(data.checked ? true:false);
  }
  

  return (
    <section >
      <Dimmer.Dimmable blurring dimmed={dimmerText!==""} >
        <div {...getRootProps({className: styles.dropzone})}>
          <input {...getInputProps()} />
          <div>
            {inputFiles.length>0 ? <p>{inputFiles[0].name}</p> :
              <div className={styles.center}>
                
                <Icon color="olive" name="cloud upload" size="huge"/>
                <div>
                {
                  
                  isDragActive ?
                    <p>{t('dropzone.indrag')}</p> :
                    <p>{t("dropzone.standard")}</p>
                }
                </div>
              </div>
            }         
          </div>
        </div>
        <Grid style={{ marginTop:10}}>  
            <Grid.Row>
              <Grid.Column width={3} verticalAlign="middle">
              <label  htmlFor ="name">
                  {t("userInfo.name")} <span style={{color:"red"}}>*</span>
                </label>
              </Grid.Column>
              <Grid.Column width={13} verticalAlign="middle">
                <Form.Field
                  id="name"
                  key="name"
                  control={Input}
                  placeholder={t("userInfo.name-placeholder")}
                  required
                  value={userName}
                  style={{width:"100%"}}
                  onChange={(event:any,data:any)  => {
                    const value =data.value!==undefined ? data.value.toString() : '';
                    setUserName(value)
                    setUserNameError(value ==='' ? t("userInfo.required"): undefined);
                    if (value!=='' && saveCookies===true) {
                      Cookies.set("ovsc-userName", value, { expires: 365 })
                    }
                    if (preview.length>0)
                    {
                      const pv: Array<filePeview> = [];
                      pv.push({...preview[0], userName:value, lang:languageString});
                      setPreview(pv);
                      onChange(pv);
                    }
                  }}
                  error={userNameError}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={3} verticalAlign="middle">
              
                <label  htmlFor ="email">
                  {t("userInfo.email")} <span style={{color:"red"}}>*</span>
                </label>

              </Grid.Column>
              <Grid.Column width={13} verticalAlign="middle">
                <Form.Field
                  id="email"
                  key="email"
                  control={Input}
                  placeholder={t("userInfo.email-placeholder")}
                  required
                  value={email}
                  style={{width:"100%"}}
                  onChange={(event:any,data:any)  => {
                    const value =data.value!==undefined ? data.value.toString() : '';
                    
                    setEmail(value);
                    const found:boolean = mailRegExp.test(value)
                    if (preview.length>0)
                    {
                      const pv: Array<filePeview> = [];
                      pv.push({...preview[0], email:found === true ? value : '', lang:languageString});
                      setPreview(pv);
                      onChange(pv);
                    }
                    
                    if (found && saveCookies===true) {
                      Cookies.set("ovsc-email", value, { expires: 365 })
                    }
                    setEmailError(!found ? t('userInfo.valid-email') : undefined)

                  }}
                  error={emailError}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={3} verticalAlign="middle">
                {t("userInfo.tel")}
              </Grid.Column>
              <Grid.Column width={13} verticalAlign="middle">
                <Form.Field
                  id="tel"
                  key="tel"
                  control={Input}
                  placeholder={t("userInfo.tel-placeholder")}
                  required
                  value={tel}
                  style={{width:"100%"}}
                  onChange={(event:any,data:any)  => {
                    const value =data.value!==undefined ? data.value.toString() : '';
                    
                    const found:boolean = telRegExp.test(value)
                    setTel(value);
                    if (preview.length>0)
                    {
                      const pv: Array<filePeview> = [];
                      pv.push({...preview[0], tel:found === true ? value: '', lang:languageString});
                      setPreview(pv);
                      onChange(pv);
                    }
                    
                    if (found && saveCookies===true) {
                      Cookies.set("ovsc-tel", value, { expires: 365 })
                    }
                    //setTelError(!found ? t('userInfo.valid-tel') : undefined)

                  }}
                  //error={telError}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16} verticalAlign="middle" >
                <Checkbox onChange={dataProtectionChange} />&nbsp;&nbsp; <a href="https://proware-solutions.de/datenschutzerklaerung/" target="_blank" rel="noopener noreferrer">{t("dataprotection")}</a><span style={{color:"red"}}>*</span>
              </Grid.Column>
            </Grid.Row>
        </Grid>
        
        
        <Grid.Row>
          <Grid.Column width={16} verticalAlign="middle" >
          <div style={{ marginTop:10, display:"flex", alignItems:"center"}}>
            Captcha<span style={{color:"red"}}>*</span>&nbsp;<ClientCaptcha width={150} height={25} captchaCode={getCaptchaCode} charsCount={5} /> &nbsp;
            <input type ="string" value={userCaptcha}  onChange={(event) =>{ setUserCaptcha(event.currentTarget.value); }}
                placeholder={t("captcha")}>
            </input>  
            </div>
            </Grid.Column>
        </Grid.Row>

        <div style={{ marginTop:10}}>
          <Button color="blue" disabled={inputFiles.length===0 || !dataProtection || captcha!==userCaptcha || userName.length===0 || !mailRegExp.test(email) } onClick={handleUpload} style={{ float: "left" }} size="large">{uploadButtonCaption}</Button>
          <Button color="blue" disabled={inputFiles.length===0} onClick={handleReset} style={{ float: "right" }} size="large">{cancelButtonCaption}</Button>
        </div>
        { dimmerText!=='' ? <Dimmer active><Loader>{dimmerText}</Loader></Dimmer>: null }
      </Dimmer.Dimmable> 
      
    </section>
  )
}